import {textHandle} from 'presentation/utils/textHandle';

type FindItemByQueryParams = {
	item: string;
	query: string;
	keywords?: string[];
};
const findItemByQuery = ({item, query, keywords}: FindItemByQueryParams): boolean => {
	const cleanQuery = textHandle(query).sanitizeText();
	const cleanItem = textHandle(item.replace(/\n/g, '')).sanitizeText();

	if (cleanItem.includes(cleanQuery)) return true;

	return (keywords ?? []).some(keyword =>
		textHandle(keyword).sanitizeText().includes(cleanQuery),
	);
};

export {findItemByQuery};
